import React from "react";

export const JobProgress = ({ progress = 0, stage = "", title, hint, testid = "job-progress" }) => (
  <div className="kcard p-5" data-testid={`${testid}-card`}>
    <div className="flex items-center justify-between gap-4">
      <div className="min-w-0">
        <div className="text-sm font-semibold text-slate-800 truncate" data-testid={`${testid}-stage`}>
          {stage || title || "Working…"}
        </div>
        {hint && <div className="text-[12px] text-slate-400 mt-0.5">{hint}</div>}
      </div>
      <div className="text-[13px] font-semibold text-slate-700 num shrink-0" data-testid={`${testid}-pct`}>{progress}%</div>
    </div>
    <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-slate-100">
      <div
        className="h-full rounded-full transition-[width] duration-500 ease-out"
        style={{ width: `${Math.max(progress, 4)}%`, background: "var(--kcsa-red)" }}
        data-testid={`${testid}-bar`}
      />
    </div>
  </div>
);
